export default __webpack_public_path__ + "static/media/visibleText.46657d9f.svg";